// @flow
import { setupHeaders } from '../honeycomb';

export const getMigrations = (endpoint: string, token: string): Promise<Response> =>
    fetch(`${endpoint}/omnia/migrations`, {
        method: 'GET',
        headers: setupHeaders(token)
    });

export const startMigration = (
    endpoint: string,
    token: string,
    source: string,
    destination: string
): Promise<Response> =>
    fetch(`${endpoint}/omnia/migrations`, {
        method: 'POST',
        headers: setupHeaders(token),
        body: JSON.stringify({ migrations: [{ source, destination }] })
    });



// WEBPACK FOOTER //
// ./src/core/api/migrations/index.js